import React, { Component } from "react";
import MyContext from '../MyContext.jsx';
import { Link } from "react-router-dom";
import { CgSearch } from 'react-icons/cg';
import Select from "react-select";
import './DistrictTargets.scss';
import DatePicker from "react-datepicker";
import DistrictTargetTable from "./DistrictTargetTable.jsx";


class DistrictTargets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      primary_targets: [],
      secondary_targets: [],
      district: '',
      executive: '',
      districts: [],
      executives: [],
      monthYear: new Date(),
    }
    this.formSubmit = this.formSubmit.bind(this);
    // this.districtSelect = React.createRef();

  }

  componentDidMount() {
    var obj_this = this;
    const url2 = `${process.env.REACT_APP_SSS}/api/getOutstandingDistricts`;
    this.context.loading(1);
    $.ajax({
      url: url2,
      data: {
        sid: this.context.user_details.sid
      },
      type: "POST"
    }).done(function (return_data) {
      console.log(return_data);
      if (return_data.status == "success") {
        obj_this.setState({
          districts: return_data.districts,
          executives: return_data.executives
        });
        // obj_this.context.loading(0);
      } else {
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function () {
      alert("Network error");
      obj_this.context.loading(0);

    });
    var obj_this = this;
    obj_this.getDistrictWiseTargets();

  }

  getDistrictWiseTargets() {
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getDistrictWiseTargets`;
    this.context.loading(1);
    $.ajax({
      url: url,
      data: {
        sid: this.context.user_details.sid,
        district_id: this.state.district?.value,
        exe_staff_id: this.state.executive?.value,
        selected_month: this.state.monthYear.toLocaleDateString('en-US')
      },
      type: "POST"
    }).done(function (return_data) {
      console.log(return_data);
      if (return_data.status == "success") {
        if (return_data.primary_targets || return_data.secondary_targets) {

          obj_this.setState({
            primary_targets: return_data.primary_targets,
            secondary_targets: return_data.secondary_targets,
          });

          if (return_data.primary_targets.length == 0 && return_data.secondary_targets.length == 0) {
            alert("Target not set");
          }
        }
        obj_this.context.loading(0);
      } else {
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function () {
      alert("Network error");
      obj_this.context.loading(0);
    });
  }

  districtChange(option) {
    this.setState({
      district: option
    });
  }
  executiveChange(option) {
    this.setState({
      executive: option
    });
  }
  setMonthYear(option) {
    this.setState({
      monthYear: option
    })
  }

  formSubmit(e) {
    e.preventDefault();
    $(".targets_page_container tr").css("backgroud-color", "");
    // if(!this.state.district.value){
    //   this.districtSelect.current.focus();
    //   return;
    // }

    var obj_this = this;
    obj_this.getDistrictWiseTargets();

  }

  render() {
    console.log(this.state.sale_return_total);

    return (
      <MyContext.Consumer>
        {context => (
          <div className="district_targets_page_container">
            <div className="page_header">
              <Link className="back_button" to="/dashboard"><i className="fas fa-arrow-left"></i></Link>
              <div className="page_title">Target</div>
            </div>
            <form className="executive_district_form" onSubmit={this.formSubmit}

            >
              <div className="blocks">
                <div className="input_grid">
                  <div className="dist_exe" style={{ display: this.context.user_details.designation == 'ASM' ? "block" : this.context.user_details.designation == 'RSM' ? "block" : this.context.user_details.designation == 'ADMIN' ? "block" : "none" }}>
                    <div className="input_label">District</div>
                    <Select
                      options={this.state.districts}
                      value={this.state.district}
                      className="district"
                      // ref={this.districtSelect}
                      onChange={e => this.districtChange(e)}
                      isClearable={true}
                      required
                    />
                    {/* <div className="input_label">Executive</div>
                    <Select
                      options={this.state.executives}
                      value={this.state.executive}
                      className="executive"
                      // ref={this.exeSelect}
                      onChange={e => this.executiveChange(e)}
                      isClearable={true}
                      required
                    /> */}
                  </div>
                  <div className="input_label">Month</div>
                  <DatePicker
                    selected={this.state.monthYear}
                    // value = {this.monthYear}
                    onChange={(date) => this.setMonthYear(date)}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                  />
                  <div className="submit_button_container">
                    <button className="submit_button">Submit</button>
                  </div>
                </div>

              </div>
            </form>

            <DistrictTargetTable
              data={this.state.primary_targets}
              title="Primary Target"
            />
            <DistrictTargetTable
              data={this.state.secondary_targets}
              title="Secondary Target"
            />


          </div>

        )}
      </MyContext.Consumer>
    )
  }
}

export default DistrictTargets;
DistrictTargets.contextType = MyContext;
